/* eslint-disable no-unused-vars */
import * as ol from '../../services/memberManagement';

export default {
  namespace: 'md',

  state: {
    getModalList: null,
    deleteModalField: null,
    getAllField: null,
    getQueryField: null,
    addModelField: null,
    copyId: null,
  },

  effects: {
    // 模型名称详情
    *getModalList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(ol.getModalNameTable, values);
      yield put({
        type: 'save',
        payload: {
          getModalList: response,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },

    // 删除模型字段
    *deleteModalField(
      { payload: { modelId, values }, callback },
      { call, put },
    ) {
      const { data: response } = yield call(
        ol.deleteModalField,
        modelId,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteModalField: response,
        },
      });
    },

    // 获取字段所有类别
    *getAllField({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(ol.getAllField, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          getAllField: response,
        },
      });
    },

    // 获取字段table数据
    *getQueryField({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(ol.getQueryField, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          getQueryField: response,
        },
      });
    },

    // 字段新增完成
    *addModelField({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(ol.addModelField, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          addModelField: response,
        },
      });
    },
    // 批量粘贴规则数据
    *pasteRule({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(ol.pasteRule, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          pasteData: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
